const UNASSIGNED_USER_FILTER_ITEM = { label: 'Unassigned', value: 'Unassigned' }

export default UNASSIGNED_USER_FILTER_ITEM
